import React, { useEffect } from "react";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import MainSVG from "./MainSVG";
import myJonCon1 from "../Static/img/main_myjob_icon_1.svg";
import myJonCon2 from "../Static/img/main_myjob_icon_2.svg";
import myJonCon3 from "../Static/img/main_myjob_icon_3.svg";
import myJonConSub from "../Static/img/main_sub_icon.svg";
import mobiImgFix from "../Static/img/main_slide_bgcolor_mobi.png";
import { useDocumentMeta } from '../useDocumentMeta';

function Main(props) {
  props.setColorData("#48486a");
  props.setHeaderClassName("realMain");
  const location = useLocation();

  const mainMent = {
    mainImgTitle: "From Design to Logic",
    mainImgTxt: "사용자가 처음 마주하는 화면의 온도부터, 뒷단에서 흐르는 데이터의 무결성까지 책임집니다. 디자이너로 시작해 대용량 데이터를 다루는 백엔드 개발자이자 인프라 운영자로 성장해 왔습니다.",
    designerTxt: "사용자의 시선으로, 시각적 아름다움을 넘어, 비즈니스의 의도가 가장 직관적으로 전달되는 UI/UX를 설계합니다.",
    publisherTxt: "비즈니스를 지탱하는 견고한 시스템을 만듭니다. Java, Node.js, PHP 등 최적의 스택으로 백엔드 아키텍처를 설계합니다.",
    developerTxt: "Proxmox 기반 가상화 환경과 ITGC 보안 체계를 구축하며, 최근에는 로컬 LLM과 데이터 분석(LightGBM)을 통해 기술의 실질적인 가치를 실험합니다",
  };

  useEffect(() => {
     const params = new URLSearchParams(location.search);
      const key = params.get("key");

      if (key) {
        props.setAccessKey(key);
        sessionStorage.setItem("accessKey", key); // 새로고침 대응용
      }

  }, []);
  useDocumentMeta("", "#ebebeb");

  return (
    <>
      <ParallaxProvider>
        <div className="whiteBg homefix overflow-hidden">
          <div className="basicWidth mainSlide ">
            <div className="msTextBox">
              <div className="msTxtBoxPt">
                <h1>{mainMent.mainImgTitle}</h1>
                <div className="subtxt">{mainMent.mainImgTxt}</div>
                <div className="subtxtBtn">
                  <Link to="/Portfolio">SEE MY WORK</Link>
                </div>
              </div>
            </div>
            <div className="msImgBox">
              <div className="msImgBoxPt">
                <MainSVG />
              </div>
            </div>
            <img src={mobiImgFix} className="mobiMainImgFix" alt="" />
          </div>

          <div className="mainInfo">
            <div className="basicWidth">
              <h2 className="tit">About Me</h2>
              <div className="mainInfoIconList">
                <ul>
                  <li>
                    <img
                      src={myJonCon1}
                      className="mainCon"
                      alt="디자이너 아이콘, 그림아래에 자가 그려져 있습니다."
                    />
                    <h3>Interface & Experience</h3>
                    <div className="txtbox">{mainMent.designerTxt}</div>
                  </li>

                  <li>
                    <img
                      src={myJonCon2}
                      className="mainCon"
                      alt="디자이너 아이콘, 그림아래에 자가 그려져 있습니다."
                    />
                    <h3>Core Logic & Data</h3>
                    <div className="txtbox">{mainMent.publisherTxt}</div>
                  </li>
                  <li>
                    <img
                      src={myJonCon3}
                      className="mainCon"
                      alt="디자이너 아이콘, 그림아래에 자가 그려져 있습니다."
                    />
                    <h3>Infrastructure & AI</h3>
                    <div className="txtbox">{mainMent.developerTxt}</div>
                  </li>
                </ul>

                <div className="subtxtBtn">
                  <Link to="/AboutMe">SEE ABOUT ME</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ParallaxProvider>
    </>
  );
}

export default Main;
